import { Wrapper, Search, Separator, Total, Showing, DefaultActions, GridToggles } from '@/components/Grid/components/header/Heading';
import { DefaultGrid, GridProvider, useBuildGrid } from '@Components/Grid';

import { useEmailTemplateStore } from '../../store';
import HeaderButtons from '../HeaderButtons'

import useColumns from './useColumns'
import useDefinitions from './useDefinitions'
import useEvents from './useEvents'

function EmailTemplateGrid() {
  useBuildGrid({
    definitions: useDefinitions(),
    columns: useColumns(),
    events: useEvents(),
  })

  return <DefaultGrid
    filters={null}
    heading={<Wrapper>
      <Search />
      <Separator />
      <GridToggles />
      <Separator />
      <Total />
      <Showing />
      <Separator />
      <DefaultActions add={<HeaderButtons />} />
    </Wrapper>}
  />
}

export default function EmailTemplateGridLayout() {
  return <GridProvider store={useEmailTemplateStore()}>
    <EmailTemplateGrid />
  </GridProvider>
}
